export default "__VITE_ASSET__UD4teuKP__"